<template>
    <form class="tsa-form">
        <slot></slot>
    </form>
</template>

<script>
export default {
    name: 'TsaForm',
    componentName: 'TsaForm',
    props: {
        model: {
            type: Object,
        },
        rules: {
            type: Object,
        },
    },
    provide(){
        return {
            tsaForm: this
        }
    },
    data () {
        return {
            fields:[],
        }
    },
    components: {},
    watch: {
        rules() {
            // remove then add event listeners on form-item after form rules change
            this.fields.forEach(field => {
                field.removeValidateEvents();
                field.addValidateEvents();
            });
        }
    },
    computed: {},
    created() {
        this.$on('tsa.form.addField', (field) => {
            if (field) {
                this.fields.push(field);
            }
        });
        this.$on('tsa.form.removeField', (field) => {
            if (field.prop) {
                this.fields.splice(this.fields.indexOf(field), 1);
            }
        });
    },
    mounted() {},
    methods: {
        objectAssign(target) {
            for (let i = 1, j = arguments.length; i < j; i++) {
                let source = arguments[i] || {};
                for (let prop in source) {
                    if (source.hasOwnProperty(prop)) {
                        let value = source[prop];
                        if (value !== undefined) {
                            target[prop] = value;
                        }
                    }
                }
            }
            return target;
        },
        resetFields() {
            if (!this.model) {
                return;
            }
            this.fields.forEach(field => {
                field.resetField();
            });
        },
        clearValidate(props = []) {
            const fields = props.length
            ? (typeof props === 'string'
                ? this.fields.filter(field => props === field.prop)
                : this.fields.filter(field => props.indexOf(field.prop) > -1)
            ) : this.fields;
            fields.forEach(field => {
                field.clearValidate();
            });
        },
        validate(callback) {
            let promise;
            if (typeof callback !== 'function' && window.Promise) {
                promise = new window.Promise((resolve, reject) => {
                    callback = function(valid, invalidFields) {
                        valid ? resolve(valid) : reject(invalidFields);
                    };
                });
            }
            let valid = true;
            let count = 0;
            // 如果需要验证的fields为空，调用验证时立刻返回callback
            if (this.fields.length === 0 && callback) {
                callback(true);
            }
            let invalidFields = {};
            this.fields.forEach(field => {
                field.validate('', (message, field) => {
                    if (message) {
                        valid = false;
                    }
                    invalidFields = this.objectAssign({}, invalidFields, field);
                    if (typeof callback === 'function' && ++count === this.fields.length) {
                        callback(valid, invalidFields);
                    }
                });
            });
            if (promise) {
                return promise;
            }
        },
        validateField(props, cb) {
            props = [].concat(props);
            const fields = this.fields.filter(field => props.indexOf(field.prop) !== -1);
            if (!fields.length) {
                return;
            }
            fields.forEach(field => {
                field.validate('', cb);
            });
        },
    },
}

</script>
<style scoped lang='less'>

</style>